import React from 'react';
import { Box } from '@mui/material';

interface DurationBarProps {
  productionDuration?: number;
  shippingDuration?: number;
  processingDuration?: number;
}

const DurationBar: React.FC<DurationBarProps> = ({
  productionDuration = 0,
  shippingDuration = 0,
  processingDuration = 0
}) => {
  const totalDuration = productionDuration + shippingDuration + processingDuration;

  if (totalDuration === 0) return null;

  return (
    <Box sx={{ display: 'flex', height: 8, borderRadius: 1, overflow: 'hidden' }}>
      {[
        { value: productionDuration, color: 'primary.main' },
        { value: shippingDuration, color: 'secondary.main' },
        { value: processingDuration, color: 'success.main' }
      ].map(({ value, color }, index) => (
        <Box
          key={index}
          sx={{
            bgcolor: color,
            width: `${(value / totalDuration) * 100}%`,
            opacity: 0.8
          }}
        />
      ))}
    </Box>
  );
};

export default DurationBar;
